import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import AirCompressorsTable from './air-compressors-table';
import AirCompressorsTile from './air-compressors-tile';
import AirCompressorsSearch from './air-compressors-search';
import AirCompressorsNavBar from './air-compressors-nav-bar';

const AirCompressorsContent = props => {
  const [activeLane, setActiveLane] = useState('ALL');
  const tileView = useSelector(state => state.airCompressors?.tileView ?? true);

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top w-100">
          <AirCompressorsSearch />
        </div>
        <div className="d-flex">
          <AirCompressorsNavBar onLaneChange={setActiveLane} activeLane={activeLane} />
          {!tileView ? <AirCompressorsTable activeLane={activeLane} /> : <AirCompressorsTile />}
        </div>
      </div>
    </div>
  );
};

export default AirCompressorsContent;
